var map = {
	"./checkmark.svg": 3499,
	"./close-circle.svg": 4921,
	"./close.svg": 9580,
	"./down-arrow.svg": 4976,
	"./down.svg": 4996,
	"./email.svg": 9920,
	"./facebook.svg": 8620,
	"./file.svg": 3114,
	"./instagram.svg": 108,
	"./left-arrow.svg": 5655,
	"./left.svg": 6931,
	"./menu.svg": 1997,
	"./minus.svg": 96,
	"./phone.svg": 9156,
	"./pinterest.svg": 2702,
	"./play.svg": 9878,
	"./play2.svg": 5256,
	"./plus.svg": 8392,
	"./right-arrow.svg": 4594,
	"./right.svg": 5686,
	"./search.svg": 5460,
	"./star.svg": 9800,
	"./twitter.svg": 4125,
	"./up.svg": 5647,
	"./x.svg": 3248,
	"./youtube.svg": 2163
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3216;